module.exports = __webpack_public_path__ + "img/19-large.dd05ac16.png";